var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnnouncementIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 42,
    height: 42,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 26v12c0 2.2 1.8 4 4 4h8l16 10c1.5.9 3.5-.2 3.5-2V14c0-1.8-2-2.9-3.5-2L18 22h-8c-2.2 0-4 1.8-4 4z",
    fill: "#f59e0b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 44l4 8c.7 1.4-.3 3-1.8 3H18c-.8 0-1.5-.5-1.8-1.2l-4-8 7.8-1.8z",
    fill: "#fbbf24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 22c5 5 5 15 0 20",
    fill: "none",
    stroke: "#f59e0b",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52 18c7 7 7 23 0 30",
    fill: "none",
    stroke: "#f59e0b",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementIcon);
export default __webpack_public_path__ + "static/media/announcement-icon.c3028abe855ebde2cf51659c0071b942.svg";
export { ForwardRef as ReactComponent };